import { z } from 'zod'

export const resetPasswordValidation = z.object({
  newPassword: z.string().min(8, 'Password must be at least 8 characters long'),
})

export type ResetPasswordValidation = z.infer<typeof resetPasswordValidation>
